import { useAuth } from '../context/AuthContext'
import type { PermissionAction } from '../types/@types/user'

export function usePermissions() {
  const { user } = useAuth()

  const can = (module: string, action: PermissionAction = 'view'): boolean => {
    if (!user) return false
    // Admins always have full access
    if (user.role === 'admin') return true
    const perm = user.permissions?.[module]
    if (!perm) return false
    return perm[`can_${action}`] ?? false
  }

  const canView   = (module: string) => can(module, 'view')
  const canCreate = (module: string) => can(module, 'create')
  const canEdit   = (module: string) => can(module, 'edit')
  const canDelete = (module: string) => can(module, 'delete')

  return { can, canView, canCreate, canEdit, canDelete }
}
